import type { DisciplineScheduleDay } from '../../interfaces'
import type { DisciplineScheduleStore } from './interfaces'

import { DisciplineScheduleEffectiveMode } from '../../enums'
import { getAllocationTutorId, toScheduleDay } from '../../discipline-schedule'

export const getters = {
  getFlow: (state: DisciplineScheduleStore): DisciplineScheduleStore['flow'] => state.flow,
  getStep: (state: DisciplineScheduleStore): DisciplineScheduleStore['step'] => state.step,
  getGrid: (state: DisciplineScheduleStore): DisciplineScheduleStore['grid'] => state.grid,
  isGridLoading: (state: DisciplineScheduleStore): boolean => state.gridLoading,
  getWeeksCount: (state: DisciplineScheduleStore): number => state.weeksCount,
  getSelected: (state: DisciplineScheduleStore): DisciplineScheduleStore['selected'] => state.selected,
  hasSlotsError: (state: DisciplineScheduleStore): boolean => state.slotsError,
  getStartDate: (state: DisciplineScheduleStore): string => state.startDate,
  getEffectiveMode: (state: DisciplineScheduleStore): DisciplineScheduleStore['effectiveMode'] => state.effectiveMode,
  isEffectiveNow: (state: DisciplineScheduleStore): boolean => state.effectiveMode === DisciplineScheduleEffectiveMode.Now,
  getEffectiveDate: (state: DisciplineScheduleStore): DisciplineScheduleStore['effectiveDate'] => state.effectiveDate,
  getPace: (state: DisciplineScheduleStore): DisciplineScheduleStore['pace'] => state.pace,
  getFilters: (state: DisciplineScheduleStore): DisciplineScheduleStore['filters'] => state.filters,
  getActivationRunId: (state: DisciplineScheduleStore): DisciplineScheduleStore['activationRunId'] => state.activationRunId,
  isRunDone: (state: DisciplineScheduleStore) => (runId: number): boolean => state.doneRunIds.includes(runId),
  isAllocating: (state: DisciplineScheduleStore): boolean => state.allocating,
  getAllocationLogs: (state: DisciplineScheduleStore): DisciplineScheduleStore['allocationLogs'] => state.allocationLogs,
  getAllocationTutors: (state: DisciplineScheduleStore): DisciplineScheduleStore['allocationTutors'] => state.allocationTutors,
  getChosenLog: (state: DisciplineScheduleStore): DisciplineScheduleStore['chosenLog'] => state.chosenLog,
  getChosenSlots: (state: DisciplineScheduleStore): DisciplineScheduleDay[] => state.chosenLog?.slot_pair.map(toScheduleDay) ?? [],
  getChosenTutorId: (state: DisciplineScheduleStore): number | null =>
    state.chosenLog ? getAllocationTutorId(state.chosenLog) : null,
  /** A tutor that was not chosen yet counts as fully available, as in legacy. */
  getChosenAvailability: (state: DisciplineScheduleStore): number => state.chosenLog?.availability ?? 100,
  getTutorReason: (state: DisciplineScheduleStore): DisciplineScheduleStore['tutorReason'] => state.tutorReason,
  getTutorSubReasons: (state: DisciplineScheduleStore): string[] => state.tutorSubReasons,
  getTutorComment: (state: DisciplineScheduleStore): string => state.tutorComment,
  hasReasonError: (state: DisciplineScheduleStore): boolean => state.reasonError,
  isConfirmed: (state: DisciplineScheduleStore): boolean => state.confirmed,
  hasConfirmError: (state: DisciplineScheduleStore): boolean => state.confirmError,
  isSaving: (state: DisciplineScheduleStore): boolean => state.saving,
}
